import { getGoToFairePosCTA } from "./shared";
export var LinkingPosIA = function LinkingPosIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getGoToFairePosCTA;
        return (_getGoToFairePosCTA = getGoToFairePosCTA(context, strictLocalize)) === null || _getGoToFairePosCTA === void 0 ? void 0 : _getGoToFairePosCTA.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getGoToFairePosCTA2, _getGoToFairePosCTA2$;
        return (_getGoToFairePosCTA2 = getGoToFairePosCTA(context, strictLocalize)) === null || _getGoToFairePosCTA2 === void 0 ? void 0 : (_getGoToFairePosCTA2$ = _getGoToFairePosCTA2.getLink) === null || _getGoToFairePosCTA2$ === void 0 ? void 0 : _getGoToFairePosCTA2$.call(_getGoToFairePosCTA2);
      }
    }
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return LINKING_YOUR_POS(strictLocalize);
    },
    getDescription: function getDescription() {
      return [TO_SET_UP_YOUR_POS_INTEGRATION(strictLocalize)];
    }
  };
};
var LINKING_YOUR_POS = function LINKING_YOUR_POS(strictLocalize) {
  return strictLocalize({
    id: "D6ODY0",
    defaultMessage: [{
      "type": 0,
      "value": "Associer le TPV"
    }]
  });
};
var TO_SET_UP_YOUR_POS_INTEGRATION = function TO_SET_UP_YOUR_POS_INTEGRATION(strictLocalize) {
  return strictLocalize({
    id: "EoCgJq",
    defaultMessage: [{
      "type": 0,
      "value": "Vous pouvez configurer votre intégration de TPV en cliquant sur l'icône utilisateur dans le coin supérieur droit du portail du commerçant, puis en sélectionnant « Connecter mon TPV ». Pour en savoir plus sur la procédure, lisez l'article du Centre d'aide. N'hésitez pas à nous contacter si vous avez besoin d'aide."
    }]
  });
};